export enum COLUMN_FORMAT {
  PERCENTAGE = 'percentage',
  CURRENCY = 'currency',
}
